<template>
  <div class="client-main-info">
    <span
      @click="$emit('id')"
      @mouseover="showFullId = true"
      @mouseleave="showFullId = false"
      class="age"
      >#{{ client.id.toString() }}
    </span>
    <!--@click="$emit('clicked')"-->
    <span
      class="toUpper"
      @click="
        showFullname = false;
        $emit('clicked');
      "
      @mouseover="showFullname = true"
      @mouseleave="showFullname = false"
      >{{ client.full_name | truncate(sizeIt()) }}</span
    >
    <!--<span class="age"> {{ client.age }}</span>-->
    <div v-if="showFullId" class="id-popup">{{ "ID:" + client.id }}</div>
    <div v-if="showFullname" class="name-popup toUpper">
      {{ client.full_name }} |
      {{
        clientAgeNewV(client.answers_log) !== undefined
          ? clientAgeNewV(client.answers_log).answer.answer
          : "Not selected Yet"
      }}
    </div>
    <a>
      <img @mouseleave="showAnsweredQuestions= !showAnsweredQuestions" @mouseenter="showAnsweredQuestions = true"  @click="openQuestionsOpt = !openQuestionsOpt" class="for-question-mark"  src="./../../../../../../public/img/icons/question-solid.svg">
    </a>
    <transition name="zoom-out"  v-if="openQuestionsOpt" >
      <div class="v-cal-dialog" v-if="openQuestionsOpt">
        <div class="v-cal-dialog__bg" @click="cancel"></div>
        <div class="v-cal-dialog-card">
          <form >
            <header class="v-cal-dialog-card__header">
                    <h5 class="quest">{{ 'QUESTIONS' }}</h5>
              <button
                  type="button"
                  class="v-cal-dialog__close"
                  @click="cancel"
              ></button>
            </header>
            <section class="v-cal-dialog-card__body">
              <div class="v-cal-fields">


                <template>


                  <div class="v-cal-input-group">
                    <!--                  <label v-if="field.label">{{ field.label }}</label>-->
                    <!--                  <event-dialog-input-->
                    <!--                          :idx="index"-->
                    <!--                    v-model="event[subfield.name]"-->
                    <!--                    :key="subfield.name + '-' + index"-->
                    <!--                    :field="subfield"-->
                    <!--                    v-for="(subfield, index) in field.fields"-->
                    <!--                  />-->


                    <div class="sc-reasons">


                      <div v-if="openReasons == false">
                        <div

                            class="qs-warning"
                        >
                          <span class="haj"></span>
                        </div>

                        <div v-for="(id, idx) in questLog" :key="id.id">

                          <div

                              class="dep-qs-form"
                              :class="{ 'dep-qs-form-even': idx % 2 === 0 }"
                          >

                                <span
                                    class="quest-line-bold"
                                    :class="{ 'dep-qs-form-even': idx % 2 === 0 }"
                                >
                            {{ id.question }}
                                </span>
                            <div class="quest-inline">
                              <client-answer-for-sc
                                  :key="answKey"
                                  :for-sc="true"
                                  :client="client"
                                  :question-id="id.id"
                                  :clientAnswerOpt = dictionaries.general.client_questions
                                  @updated="fetchClients"
                              ></client-answer-for-sc>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </template>
              </div>
            </section>
            <footer class="footer">
            <textarea
                class="form-control input-sm comment-box-scheduled "
                placeholder="Comment"
                v-model.trim="questionComment"
                maxlength="160"
            ></textarea>
            <span class="text-counter-scheduled"
            >{{ questionComment.length }}/160</span
            >
            <p v-if="questionCommentError.length > 0" class="help-block">
              {{ questionCommentError }}
            </p>
            </footer>

              <button @click="setAnswer(140, client.id,questionComment)" type="submit" class="for-save"
                      :class="{'for-non-raw-comment': forHistory.length == 0}"
              >
                {{ 'SAVE' }}
              </button>
<div class="for-raw-history" v-if="forHistory.length > 0">
  <table class="history-table" v-for="(h,idx) in forHistory"  :key="idx">
    <thead>{{h.raw_comment}}</thead>
    <tbody>
    <tr>
      <td>
        {{formatDateTable(h.created_at)}}
      </td>
      <td>
        {{formatDateTableTime(h.created_at)}}
      </td>
      <td>
        {{h.user.full_name}}
      </td>
    </tr>
    </tbody>
  </table>
<!-- <p v-for="(h,idx) in forHistory"  :key="idx" class="rawHistory">{{h}}</p>-->
</div>
          </form>
        </div>
      </div>
    </transition>

    <div class="sc-reasons-hovering-popup" :class="{'d-none':client.answers_log.length === 0 || (client.answers_log.length === 1 && client.answers_log[0].answer_id === 140)}" v-if="showAnsweredQuestions">
      <div class="table-responsive">
        <table class="table">
          <tbody>
             <tr v-for="(id, idx) in questLog" :key="id.id">
               <td v-if="getAnswer(client.answers_log,id)">
                {{client.answers_log[idx] ?id.question +' - '+ getAnswer(client.answers_log,id):'' }}
               </td>
             </tr>
          </tbody>
        </table>
      </div>
    </div>




  </div>
</template>

<script>
import ClientAnswerForSc from "../../clients_table.sub_feature.company/components/questioner/ClientAnswerForSc.component";
import { mapState } from "vuex";
import apiClientCreator from "@/helpers/api/request";
import ClientModel
  from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/ClientModel";
import moment from "moment";

export default {
  components:{
    ClientAnswerForSc
  },
  name: "client-main-info",

  props: {
    client: {
      type: Object,
      required: true
    },

  },
  data() {
    return {
      showFullname: false,
      showFullId: false,
      openQuestionsOpt: false,
      answKey: 0,
      openReasons:false,
      questLog: [
        {
          id: 1,
          question: "Occupation"
        },
        {
          id: 2,
          question: "What Signals?"
        },
        {
          id: 3,
          question: "Trading Time"
        },
        {
          id: 4,
          question: "Invested So Far"
        },
        {
          id: 5,
          question: "How Much Profit Expected?"
        },
        {
          id: 6,
          question: "Plan To Invest?"
        },
        {
          id: 7,
          question: "Amount Of Broker Or Names"
        },
        {
          id: 8,
          question: "Amount Of Signals?"
        },
        {
          id: 9,
          question: "Reason for trading"
        },
        {
          id: 10,
          question: "Originaly From"
        },
        {
          id: 11,
          question: "Age"
        },
        // {
        //   id: 12,
        //   question:"Raw"
        // }
      ],
      showAnsweredQuestions:false,
      questionComment:'',
      questionCommentError:'',
      forHistory:[]
    };
  },
  computed: {
    ...mapState("clients", [
      "dictionaries",
    ])
  },
  watch:{

  },
  mounted() {
    if(this.client.answers.length > 0){
      this.client.answers.find(all =>{
        if(all.raw_comment !== null){

          this.forHistory.push(all)
        }
      })
    }

    // this.openQuestionsOpt = true;
  },
  methods: {
    formatDateTableTime(date){
      return moment(String(date)).format("HH:mm");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },
    setAnswer(answerId, clientId , questionComment){
      apiClientCreator(`client/answer/${clientId}`)
          .post("", {
            answer_id: answerId,
            raw_content : questionComment
          })
          .then(async res => {
            return res;
          });
      this.$emit('updated');
      this.openQuestionsOpt = false;
      this.questionComment = '';
    },


    getAnswer(x,q){
    if(q.id != 12 ){


      let ans = x.find(answer=>{
          return answer.answer.question_id === q.id
      })

      return ans  ? ans.answer.answer : false
    }
    },
    clientAgeNewV(ansLog) {
      return ansLog.find(answer => answer.answer.question_id == 11);
    },
    sizeIt() {
      if ((this.client.id.toString() + this.client.full_name).length >= 16) {
        return 7;
      } else {
        return 100;
      }
    },
    cancel() {
      this.close();
    },
    close() {
      this.$emit('updated');
      this.openQuestionsOpt = false;
      this.questionComment = '';
      // Timeout for the animation complete before destroying
      setTimeout(() => {
        //this.$destroy();
        //this.$el.remove();
      }, 150);
    },
    fetchClients(withStats) {
      // this.$store.commit("clients/setDebounceAll", false);

      this.selectedClientsFrom = [];
      this.sendUpdated = false;
      let path = "client/list";
      if (this.selectedMainTab === "affiliation") {
        path = "affiliation/client/click";
      }

      let apiClient = apiClientCreator(path);
      this.changeResesColor = true;
      // this.$store.commit("clients/setLoading", true);

      const queryParams = this.getQueryParams();
      // this.$store.commit("clients/setClientsDashBoardQueryParams", queryParams);
      this.getQueryParamsToMs = queryParams;
      this.resetMsAfterFilter = true;

      const clients = [];
      const filteredClients = [];
      this.filteredClientIds = [];

      apiClient
          .get("", { params: queryParams })
          .then(res => {
            this.changeResesColor = true;
            this.resetMsAfterFilter = false;

            if (this.selectedMainTab === "affiliation") {
              this.clickedClients = res.data.data;
            } else {
              res.data.data.forEach(function(data) {
                clients.push(new ClientModel(data));
              });
            }
            if (
                !withStats &&
                this.selectedMainTab !== "users" &&
                this.selectedMainTab !== "brokers"
            ) {
              if (!this.stopProcess) {
                this.updateStats();
              }
            }

            this.filteredClientIds = filteredClients;
            this.clients = clients;
            this.pagination.currentPage = res.data.current_page;
            this.pagination.perPage = res.data.per_page;
            this.pagination.from = res.data.from;
            this.pagination.to = res.data.to;
            this.pagination.lastPage = res.data.last_page;
            this.pagination.total = res.data.total;
            this.resetCalendars = false;
            this.resetMultiSelects = false;
            this.sendUpdated = true;
            this.changeResesColor = false;
            // this.$store.commit("clients/setLoading", false);

            if (this.filters.enlarge_leads) {
              // this.$store.commit("clients/setEnlargeCompanyTable", true);
            } else {
              // this.$store.commit("clients/setEnlargeCompanyTable", false);
            }

            return res;
          })
          .catch(e => {
            // this.$store.commit("main/setShowVikiMsg", {
            //   show: true,
            //   msg:
            //       "Connection Error!" + " " + " Error Status: " + e.response.status,
            //   type: "ERROR",
            //   op: { type: "SYSTEM" }
            // });

            // this.$store.commit("clients/setLoading", false);
          });
    },

  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
  font-size: 13px;
}

.client-main-info {
  position: relative;
  /*cursor: pointer;*/
  display: inline;
  /*
       font-size: 10pt;
      */
  margin-left: 5px;
  text-transform: capitalize;
}

.age {
  font-size: 13px;
  /* font-weight: 700; */
}

.id-popup {
  position: absolute;
  padding: 4px;
  top: 24px;
  left: 0px;
  z-index: 10001;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #4d4f50;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-family: Montserrat;
  width: fit-content;
}

.name-popup {
  position: absolute;
  padding: 8px;
  top: 24px;
  right: 0px;
  z-index: 10001;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #4d4f50;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-family: Montserrat;
  width: max-content;
}
.client-main-info span {
  font-size: 13px;
}
.toUpper {
  text-transform: capitalize;
}
.for-question-mark{
  position: absolute;
  left: 158px;
  top: 5px;
  width: 7px;
  cursor: pointer;
}
.for-question-mark:hover{
  transform: scale(1.2);
  transition: 0.5s ease-in-out;
}
.zoom-out-enter-active,
.zoom-out-leave-active {
  transition: opacity 150ms ease-out;
}
.zoom-out-enter-active .animation-content,
.zoom-out-enter-active .animation-content,
.zoom-out-leave-active .animation-content,
.zoom-out-leave-active .animation-content {
  transition: transform 150ms ease-out;
}

.zoom-out-enter,
.zoom-out-leave-active {
  opacity: 0;
}
.zoom-out-enter .animation-content,
.zoom-out-enter .animation-content,
.zoom-out-leave-active .animation-content,
.zoom-out-leave-active .animation-content {
  transform: scale(1.05);
}
.input-flex-wrapper{
  display: flex;
  align-items: baseline;
  width: 96%;
}
.input-flex-wrapper div:nth-child(1), .input-flex-wrapper div:nth-child(3){
  flex: 2;
  text-align: center;
}
.input-flex-wrapper div:nth-child(2){
  flex: 1;
  text-align: center;
  font-weight: 600;

}
/*.input-flex-wrapper div:nth-child(4){*/
/*  flex: 1;*/
/*  text-align: center;*/
/*  font-weight: 600;*/

/*}*/
.input-flex-wrapper div:nth-child(1) span, .input-flex-wrapper div:nth-child(3) span,.input-flex-wrapper div:nth-child(4) span{
  padding: 10px;
  background-color: #e6e6e6;
  border: 1px solid lightgrey;
  border-radius: 5px;
  font-weight: 600;
}
section.form-control{
  height: 40px;
}
.add-tag-menu-item {
  margin: 6px;
  font-size: 12px !important;
  text-transform: uppercase !important;
}

.add-tag-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.lang-dropdown {
  padding: 5px;
  height: 404px;
  width: 446px;
  overflow-x: hidden;
  list-style: none;
  margin-bottom: 10px;
}
.sc-reasons{
  padding: 0px 20px;
}
.sc-reasons-hovering-popup{
  /*position: absolute;*/
  /*min-width: 281px;*/
  /*background-color: white;*/
  /*font-size: 10px;*/
  /*z-index: 1;*/
  /*border-radius: 7px;*/
  position: absolute;
  top: 20px;
  right: -2px;
  z-index: 10001;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  margin-bottom: 0px;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #4d4f50;
  font-family: Montserrat;
}
v-cal-dialog .v-cal-dialog-card__body {
  max-height: 570px !important;

}
.selected-reason {
  background-color: #c1c1c1;
}
span.text-counter-scheduled {
  position: absolute;
  left: 445px;
  top: 566px;
  font-size: 9px;
  color: #d7d7d7;
}
.help-block{
  color: red;
}
.add-reasons{
  cursor: pointer;
  color: red;
  position: relative;
  left: 200px;
}
.res-it-self{
  cursor: pointer;
  position: relative;
  left: 206px;
  font-size: 16px;
}
.comment-box-scheduled {
  min-width: 444px;
  /*margin-top: 39px;*/
}
.for-res{
  cursor: pointer;
  margin-top: 13px;
}
.haj{
  padding-left: 30%;
}
.dot {
  height: 5px;
  width: 5px;
  background-color: red;
  border-radius: 50%;
  /* margin-bottom: 2px; */
  display: inline-block;
  position: absolute;
  top: 159px;
  left: 15px;
}
.for-date {
  top: 27px;
  /* margin-bottom: 7px; */
  position: relative;
  left: 224px;
}

.v-cal-button{
  position: relative;
  top: 20px;
  margin-top: 25px;
}
.forTool{
  position: absolute;
  background: black;
  color: white;
  border: 1px solid black;
  border-radius: 7px;
  right: -34px;
  bottom: 40px;
  font-family: "Montserrat" !important;
}
.footer{
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 28px;
  /*padding-top: 73px;*/
  border-top: 1px solid #eaf0f4;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  height: 80px;
}
.for-save{
  position: relative;
  /*top: -4px;*/
  right: 10px;
  float: right;
  /* margin-top: -35px; */
  border-color: #44a2d2;
  background-color: #44a2d2;
  color: #fff;
  border-radius: 4px;
}
.d-none{
  display: none;
}
.table{
  margin-top: 2px;
}
.for-raw-history{
  background-color:#f1f1f1 ;
  margin-top: 30px;
  min-height: 90px;
  padding-top: 6px;
  max-height: 190px;
  overflow-y: scroll;
  transform: scaleX(-1);
}
.rawHistory {
  font-family: "Montserrat" !important;
  font-size: 14px;
  padding: 2px;
}
.history-table td,.history-table tr{
  border: 3px solid #dee2e6;

}
table.history-table{
  min-width: 98%;
  margin: 5px;
  transform: scaleX(-1);
}
.for-non-raw-comment{
  top: -4px;
}
.history-table thead{
      word-break: break-all;
}
.for-raw-history::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.for-raw-history::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.for-raw-history::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
</style>
